import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbdef61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = {
  key: 0,
  class: "search-result-container"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["SearchInput"], {
      ref: "searchInput",
      class: "search-input",
      name: "주소검색",
      placeholder: "주소를 검색하세요",
      value: $props.searchKeyword,
      hideClearBtn: false,
      "onUpdate:value": $setup.emitOnChangedSearchKeyword,
      onClearText: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowSearchResult(false))),
      onOnInput: $setup.searchAddressAfterTime,
      onOnEnter: $setup.searchAddress
    }, null, 8 /* PROPS */, ["value"]),
    (!!$setup.addressSearchInfos.length && $setup.shouldShowSearchResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressSearchInfos, (address, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "search-result",
              key: index,
              onClick: ($event: any) => ($setup.getAddressCoordinate(address))
            }, [
              _createElementVNode("p", {
                innerHTML: 
            $setup.DOMPurify.sanitize($setup.getTextFocusedKeyword(address.roadAddress ?? ''))
          
              }, null, 8 /* PROPS */, _hoisted_4)
            ], 8 /* PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}